<template>
  <v-card
    :flat="isCreation"
    :class="!isCreation ? 'home-page-card' : 'home-creation-card'"
  >
    <v-icon class="plus-icon" x-large v-if="isCreation"> mdi-plus </v-icon>
    <v-img
      v-if="!isCreation"
      class="home-page-card-illustration"
      :src="picture"
    >
    </v-img>
    <div v-if="!isCreation" class="right-card-container">
      <v-card-title class="card-title">
        {{ title }}
      </v-card-title>
      <v-card-title class="card-sub-title">
        {{ detailsText }}
      </v-card-title>
      <v-card-text v-if="link">
        <a @click="stopPropagagation" :href="link" target="_blank">{{
          $t('homePageCard.link')
        }}</a>
      </v-card-text>
      <v-card-actions>
        <v-chip
          v-for="tag in tags"
          large
          :color="setChipClass(tag)"
          :key="tag"
          >{{ tag }}</v-chip
        >
      </v-card-actions>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'HomePageCard',
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
    details: {
      type: String,
      default: '',
    },
    picture: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: null,
    },
    tags: {
      type: Array,
      default: null,
    },
    isCreation: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  data() {
    return {};
  },
  mounted() {},
  computed: {
    detailsText() {
      if (this.details) {
        if (this.details.length <= 134) {
          return this.details;
        }

        let truncated = this.details.substring(0, 135);
        const lastSpaceIndex = truncated.lastIndexOf(' ');
        return truncated.substring(0, lastSpaceIndex) + ' ... ';
      }
      return '';
    },
  },

  methods: {
    setChipClass(tag) {
      switch (tag) {
        case this.$t('homePage.cardTags.free'):
          return 'orange';
        case this.$t('homePage.cardTags.welcome'):
          return 'black';
        case this.$t('homePage.cardTags.event'):
          return 'green';
        case this.$t('homePage.cardTags.published'):
          return 'primary';
        case this.$t('homePage.cardTags.approved'):
          return 'primary';
        case this.$t('homePage.cardTags.expired'):
          return 'red';
      }
      // return this.colorTags[tag];
    },
    stopPropagagation(event) {
      // annule le clique sur la card code promo pour ne pas créer le path si clique sur le lien
      event.stopPropagation();
    },
  },
};
</script>

<style lang="sass" scoped>

.home-page-card
  height: 200px;
  width: 600px;
  cursor: pointer;

.home-creation-card
  height: 200px;
  width: 600px;
  border: 2px dashed darkgrey !important;
  background-color: transparent !important;
  cursor: pointer;

.right-card-container
  height: 200px;
  margin-left: 200px;
  padding: 15px;

.home-page-card-illustration
  height: 200px;
  width: 200px;
  float: left;

.plus-icon
  position: absolute;
  top: 41%;
  left: 46%;

.card-title
  font-size: 1.5em;

.card-sub-title
  color: #5c5c5c;
  font-size: 1.2em;

span.v-chip
   color: #fff !important;
</style>
